import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wh",
  "use": "icon-wh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wh\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 888c207.66 0 376-168.34 376-376S719.66 136 512 136 136 304.34 136 512s168.34 376 376 376z m0 72C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z\" fill=\"#008df0\" p-id=\"2448\" /><path d=\"M480 760m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z\" fill=\"#008df0\" p-id=\"2449\" /><path d=\"M512 612v68a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-68c0-35.346 28.654-64 64-64 71.797 0 130-58.203 130-130S583.797 288 512 288 382 346.203 382 418H318C318 310.857 404.857 224 512 224s194 86.857 194 194-86.857 194-194 194z\" fill=\"#008df0\" p-id=\"2450\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wh.svg
// module id = kedP
// module chunks = 77